import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit {
  public buttonText: string = this.ts.instant('INFO_DIALOG.BUTTONS.Close');

  constructor(public dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string, message: string, buttonText: string },
    private ts: TranslateService) { 
      if (this.data.buttonText) {
        this.buttonText = this.data.buttonText;
      }
    }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }

}
